import {Headers, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {AccessReference} from '../models/access-reference.model';
import {Location} from '@angular/common';
import {isUndefined} from 'util';
import {AbstractControl, FormArray, FormControl, FormGroup} from '@angular/forms';
import {ElementRef} from '@angular/core';
import * as FileSaver from 'file-saver';
import {UUID} from 'angular2-uuid';
import {TagItem, TagItemSettings} from '../models/tag-item.model';
import {Route} from '@angular/router';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {Alert} from '../../delivery/models/alert.model';
import { Subscriber } from 'rxjs';
import { ErrorResponse } from '@shared/models/error-response.model';

export abstract class Utilities {
	static APPCONFIGENVIRONMENT: AppConfigEnvironment;
	static FISCAL_CODE_IT_REG_EX: string = '(?:[B-DF-HJ-NP-TV-Z](?:[AEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}' +
		'[\\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])' +
		'(?:[A-MZ][1-9MNP-V][\\dLMNP-V]{2}|[A-M][0L](?:[\\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z]';
	static FISCAL_CODE_IT_LENGTH: number = 16;
	static METADATA: string = 'metadata';
	static ACCESS_REFERENCE: string = 'accessReference';
	static CURRENT_ROUTE: string = 'currentRoute';
	static NEW_LOGIN: string = 'newLogin';
	static SESSION_ID: string = 'sessionId';
	static LOCAL_EMAIL: string = 'localEmail';

	static patternOnlyNumber: any = /^\d+$/;
	static patternFloat: any = /^[0-9]+(\.[0-9]{1,2})?$/;
	static patternOnlyIntergerNumber: any = /^-?[0-9][^\\.]*$/;
	static patternNumber: string = '^[0-9]*$';
	static patternPhoneNumber: RegExp = /^[+]{0,1}[(]{0,1}[0-9]{1,4}[)]{0,1}[-]{0,1}[0-9]*$/;
	static patternMobileInternationalNumber: RegExp = /^(([+]|00)39)?((3[1-9][0-9]))(\d{6,7})$/;	
	static patternEmail: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	static patternMultiEmail: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))(\s*;\s*(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))))*$/;
	static patternOnlyLetters: string = '^[a-zA-z][a-zA-Z ]*$';
	static patternAlphanumeric: string = '^[a-zA-Z0-9]*$';
	// come è possibile che le ultime lettere della targa possano essere 0?
	static patternItalianPlate: string = '^[a-zA-z]{1,2}[0-9]{1,5}[a-zA-z]{0,4}$';
	// estensione della targa auto con quella degli scooter
	static patternItalianCarScooterPlate: string = '^[a-zA-z]{1,2}[0-9]{1,5}[a-zA-z]{0,4}[0-9]{0,2}$';
	static patternNotInitWhiteSpace: string = '^[A-Za-z0-9][A-Za-z0-9 ]*$';
	static patternGlassNumberPrefix: string = '^NEG[0-9]+$';
	static patternWorkingNumberPrefix: RegExp = /^NE[ACM][0-9]+$/;
	static patternPoNumber: string = '^NE[a-zA-Z]{3}[0-9]+$';
	static patternMessage: string = '(?:(?!\\(\\\').)*(?=\\\'\\))';
	static pattern4number2decimal: string = "(?![0]{5,})(^[+]?[0-9]{0,4}(?:[.][0-9]{0,2})?$)";
	static allowedExtensions: string[] = ['.csv', '.doc', '.docx', '.odt', '.ods', '.odg', '.odp', '.pdf', '.pps', '.txt', '.rtf', '.xls', '.xlsx', '.bmp', '.jpg', '.jpeg', '.png', '.tiff', '.psd'];
	static patternFileNameWithNoSpecialChars = '^[a-zA-Z0-9\-\_\ ]+(\\.(' + Utilities.allowedExtensions.map(x => x.slice(1)).join("|") +' ))$';

	// Da eliminare:
	// per evitare il side-effect, meglio un metodo getCommoditiesID
	// che restituisce direttamente l'array di ID
	// e fare un altro metodo che lo inserisce nell'header
	// SRP: single responsibility principle - una funzione deve fare 1 cosa sola
	static setOptionsWithNemoCommodityID(values: string[], options?: RequestOptionsArgs): any {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}
		if (!values) {
			values = [];
		}
		options.headers.append('commodities', values.filter(x => x).join(','));
		return options;
	}

	private static setOptionWithOAut(options?: RequestOptionsArgs): RequestOptionsArgs {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}

		const accessReference: AccessReference = Utilities.getAccessReference();
		if (!accessReference) {
			return options;
		}

		options.headers.delete('authToken');
		options.headers.append('authToken', accessReference.access_token);
		return options;
	}

	static setRequestOptionGW(commoditiesID: number[], options?: RequestOptionsArgs): RequestOptionsArgs {
		options = Utilities.setOptionWithOAut(options);
		options = Utilities.setOptionsWithCenterID(commoditiesID, options);

		Utilities.headerSetApiKey(options, Utilities.APPCONFIGENVIRONMENT.apiKey);
		return options;
	}

	static setRequestOptionAppointment(externalRefs: number[], options?: RequestOptionsArgs): RequestOptionsArgs {
		options = Utilities.setOptionWithOAut(options);
		options = Utilities.setOptionsWithCenterID(externalRefs, options);

		Utilities.headerSetApiKey(options, Utilities.APPCONFIGENVIRONMENT.DELIVERY_APPOINTMENTS_APIKEY);
		return options;
	}

	static addCustomHeader(key: any, value: any, options: RequestOptions): RequestOptions {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}
		options.headers.delete(key);
		options.headers.append(key, value);
		return options;
	}

	static setNemoTyreRequestOptions(commoditiesID: string[]): RequestOptionsArgs {
		const options: any = new RequestOptions();
		options.headers = new Headers();

		const commoditiesString: string = commoditiesID.toString();
		if (commoditiesString.trim() !== '') {
			options.headers.append('commodities', commoditiesString);
		}

		return options;
	}

	static headerSetApiKey(options: RequestOptionsArgs, apiKey: string): void {
		options.headers.delete('apikey');
		options.headers.append('apikey', apiKey);
	}

	static setRequestOptionAUTH(options?: RequestOptionsArgs): RequestOptionsArgs {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}

		const accessReference: AccessReference = Utilities.getAccessReference();
		if (!accessReference) {
			return options;
		}
		const bearer: string = 'Bearer ' + accessReference.access_token;
		options.headers.delete('Authorization');
		options.headers.append('Authorization', bearer);

		return options;
	}

	static updateOptions(options: RequestOptionsArgs): RequestOptionsArgs {
		const accessReference: AccessReference = Utilities.getAccessReference();
		if (!accessReference) {
			return options;
		}

		if (options.headers.get('apikey') && options.headers.get('authToken')) {
			options.headers.delete('apikey');
			options.headers.append('apikey', Utilities.APPCONFIGENVIRONMENT.apiKey);
			options.headers.delete('authToken');
			options.headers.append('authToken', accessReference.access_token);
		} else {
			const bearer: string = 'Bearer ' + accessReference.access_token;
			options.headers.delete('Authorization');
			options.headers.append('Authorization', bearer);
		}
		return options;
	}

	static setOptionsWithCenterID(values: number[], options?: RequestOptionsArgs): any {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}
		options.headers.append('commodities', values.toString());
		return options;
	}

	static extractCode(location: Location): string {
		let code: string;
		if (!location) {
			return null;
		}
		const url: string = location.path();
		if (url && url.search('code=') >= 0) {
			const start: number = url.indexOf('code=');
			const end: number = url.indexOf('&', start);
			if (end === -1) {
				code = url.substring(start + 5);
			} else {
				code = url.substring(start + 5, end);
			}
		}
		return code;
	}

	static extractParameter(location: Location, parameter: string): string {
		let value: string;
		const length: number = parameter.length + 1;
		if (!location) {
			return null;
		}
		const url: string = location.path();
		if (url && url.search(parameter + '=') >= 0) {
			const start: number = url.indexOf(parameter + '=');
			const end: number = url.indexOf('&', start);
			if (end === -1) {
				value = url.substring(start + length);
			} else {
				value = url.substring(start + length, end);
			}
		}
		return value;
	}

	static getCurrentRoute(): string {
		return localStorage.getItem(Utilities.CURRENT_ROUTE);
	}

	static getAccessReference(): AccessReference {
		return JSON.parse(localStorage.getItem(Utilities.ACCESS_REFERENCE)) as AccessReference;
	}

	static getMetadata(): any {
		return JSON.parse(localStorage.getItem(Utilities.METADATA));
	}

	static getSessionID(): string {
		if (Utilities.isVoid(localStorage.getItem(Utilities.SESSION_ID))) {
			Utilities.setSessionID();
		}
		return localStorage.getItem(Utilities.SESSION_ID);
	}

	static setSessionID(): void {
		localStorage.setItem(Utilities.SESSION_ID, Utilities.getUUID());
	}

	static getUUID(): string {
		return UUID.UUID();
	}

	static isEmptyObject(obj: any): boolean {
		return (obj && (Object.keys(obj).length === 0));
	}

	static compareArray(a1: any[], a2: any[]): boolean {
		if (Utilities.isVoid(a1) || Utilities.isVoid(a2) || a1.length !== a2.length) {
			return false;
		}
		for (let i: number = 0; i < a1.length; i++) {
			if (a1[i] !== a2[i]) {
				return false;
			}
		}
		return true;
	}

	static includesArray(a1: any[], a2: any[]): boolean {
		if (Utilities.isVoid(a1) || Utilities.isVoid(a2) || a1.length !== a2.length) {
			return false;
		}
		for (let i: number = 0; i < a1.length; i++) {
			if (!a1.includes(a2[i])) {
				return false;
			}
			if (!a2.includes(a1[i])) {
				return false;
			}
		}
		return true;
	}

	static isLocalStorageNameSupported(): void {
		if (typeof localStorage === 'object') {
			try {
				localStorage.setItem('localStorage', 'localStorage');
				localStorage.removeItem('localStorage');
			} catch (e) {
				alert('Il tuo browser non è supportato in modalità "in incognito"');
			}
		}
	}

	static isVoid(value: any): boolean {
		return value === null || isUndefined(value);
	}

	static isNull(value: any): boolean {
		return value == null;
	}

	static isEmpty(value: any): boolean {
		return value === null || isUndefined(value) || value === '' || Utilities.isVoidArray(value) || Utilities.isVoidObject(value);
	}

	static isVoidArray(arr: any): boolean {
		return Array.isArray(arr) && (!arr.length ||	JSON.stringify(arr) === '[]');
	}

	static isVoidObject(obj: any): boolean {
		return (
			Object.getPrototypeOf(obj) === Object.prototype &&
			(
				JSON.stringify(obj) === '{}' || 
				Object.keys(obj).length === 0 ||
				!(Object.keys(obj).length>0 && !!Object.keys(obj).reduce((acc, val) => acc && obj.hasOwnProperty(val)))
			)
		);
	}

	static pressedEnter(event: any): boolean {
		return event instanceof KeyboardEvent && (event.keyCode === 13 || event.code === 'Enter' || event.code === 'NumpadEnter');
	}

	static setAsyncMinLengthValidator(control: AbstractControl, minLength: number): void {
		const val: any = control.value;
		if (!Utilities.isVoid(val) && val.length > 0 && val.length < minLength) {
			control.setErrors({minLength: true});
		} else {
			control.clearAsyncValidators();
		}
	}

	static isScrolledIntoView(el: ElementRef, offSet?: number): boolean {
		const elemTop: number = el.nativeElement.getBoundingClientRect().top;
		const elemBottom: number = el.nativeElement.getBoundingClientRect().bottom;
		const innerHeight: number = window.innerHeight;
		return (elemTop > 0 && elemTop <= innerHeight)
			|| (elemBottom > 0 && elemBottom <= innerHeight)
			|| (elemTop < 0 && elemBottom > 0);
	}

	static getFiscalCodeValidator(locale?: string): any {
		let res: any;
		if (Utilities.isVoid(locale) || locale === 'it-IT') {
			res = {
				reg_ex: new RegExp(Utilities.FISCAL_CODE_IT_REG_EX, 'i'),
				valid_length: Utilities.FISCAL_CODE_IT_LENGTH
			};
		}
		return res;
	}

	static getLastAlertFromPolling(alerts: Alert[], userID: string): any {
		let firstAlert: Alert = null;
		const mAlerts: any = [];
		if (!Utilities.isVoid(alerts) && alerts.length > 0) {
			let isFirstAlert: boolean = true;
			alerts.forEach(
				alert => {
					if (isFirstAlert) {
						firstAlert = alert;
						isFirstAlert = false;
					}
					if (userID !== alert.id_sender_ext && Utilities.isVoid(alert.date_read) && !Utilities.isVoid(alert.id_thread)) {
						mAlerts.push(alert);
					}
				});
		}
		return { alerts: mAlerts, firstAlert: firstAlert };
	}

	static downloadFile(data: Response, fileName: string): void {
		const fileBlob: Blob = data.blob();
		this.downloadBlob(fileBlob, fileName);
	}

	static downloadFileFromBase64(base64String: string, fileName: string): void {
		const binary: string = atob(base64String);
		const array: Uint8Array = new Uint8Array(binary.length);
		for (let i: number = 0; i < binary.length; i++) {
			array[i] = binary.charCodeAt(i);
		}
		this.downloadBlob(array, fileName);
	}

	static downloadBlob(fileBlob: any, fileName: string): void {
		this.downloadBlobWithType(fileBlob, fileName, fileBlob.type);
	}

	static downloadBlobWithType(fileBlob: any, fileName: string, fileType: any): void {

		let extension: string;
		let mimeType: string;

		// extension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
		extension = fileName.toLowerCase().split('.').pop();
		switch (extension) {
			case 'jpeg':
			case 'jpg':
				mimeType = 'image/jpeg';
				break;
			case 'png':
				mimeType = 'image/png';
				break;
			case 'pdf':
				mimeType = 'application/pdf';
				break;
			case 'doc':
				mimeType = 'application/msword';
				break;
			case 'zip':
				mimeType = 'application/zip';
				break;
			default:
				//mimeType = 'application/pdf';
				mimeType = fileType;  // così se non trova l'estensione usa il tipo del file
		}

		const blob: Blob = new Blob([fileBlob], {type: mimeType});

		/*
		const userAgent = window.navigator.userAgent;
		if (!Utilities.isVoid(userAgent) &&
			userAgent.match('FxiOS') || //FF iOS
			userAgent.match('CriOS') || //Chrome iOS
			userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) { //Safari & Opera iOS
			const fileURL = window.URL.createObjectURL(blob);
			window.open(fileURL);
		} else {
			FileSaver.saveAs(blob, fileName);
		}
		*/
		FileSaver.saveAs(blob, fileName);
	}

	static getBlob(data: Response, fileName: string): Blob {
		let extension: string;
		let mimeType: string;

		// extension = fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
		extension = fileName.toLowerCase().split('.').pop();

		switch (extension) {
			case 'jpeg':
			case 'jpg':
				mimeType = 'image/jpeg';
				break;
			case 'png':
				mimeType = 'image/png';
				break;
			case 'pdf':
				mimeType = 'application/pdf';
				break;
			case 'doc':
				mimeType = 'application/msword';
				break;
			case 'zip':
				mimeType = 'application/zip';
				break;
			default:
				//mimeType = 'application/pdf';
				mimeType = data.blob().type;  // così se non trova l'estensione usa il tipo del file
		}
		return new Blob([data.blob()], {type: mimeType});
	}

	static parseFilenameFromContentDisposition(contentDisposition: any): string | null {
		if (!Utilities.isVoid(contentDisposition)) {
			const matches: any = /filename="(.*?)"/g.exec(contentDisposition);
			return matches && matches.length > 1 ? matches[1] : null;
		}
		return null;
	}

	static getQuery(obj: any): string {
		let haveAlreadyParams: boolean = false;
		let query: string = '?';
		Object.keys(obj).map((key) => {
			const value: any = (typeof obj[key] === 'string') ? obj[key].trim() : obj[key];
			if (!Utilities.isVoid(value) && value.toString().length > 0) {
				if (haveAlreadyParams) {
					query += '&';
				}
				query += key + '=' + value;
				haveAlreadyParams = true;
			}
		});
		if (!haveAlreadyParams) {
			return '';
		}

		return query;
	}

	static escapeBase64(file_content: string): string {
		if (!Utilities.isVoid(file_content)) {
			return file_content.substring(file_content.indexOf(',') + 1);
		}
		return null;
	}

	static scrollUp($: any): void {
		Utilities.scrollTo($, 0);
	}

	static scrollTo($: any, y: number): void {
		if ($('.amd-page--webdealer').length > 0) {
			$('.amd-page--webdealer').find('.mat-sidenav-content').animate({scrollTop: y}, 700);
		} else {
			$('.amd-page').find('.mat-sidenav-content').animate({scrollTop: y}, 700);
		}
	}

	static scrollUpToElementById(id: string): void {
		if (id && id !== '') {
			const el: HTMLElement = document.getElementById(id);
			el.scrollIntoView({ behavior: 'smooth' });
		}
	}

	static getElementOffset(nativeElement: any): ElementOffset | null {
		try {
			const boundingClientRect: any = nativeElement.getBoundingClientRect();
			const rect: any = boundingClientRect,
				scrollLeft: number = window.pageXOffset || document.documentElement.scrollLeft,
				scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;
			return new ElementOffset(rect.top + scrollTop, rect.left + scrollLeft);
		} catch (error) {
			return null;
		}
	}

	static markFormGroupTouchedAndDirty(formGroupOrArray: FormGroup | FormArray): void {
		if (formGroupOrArray.controls) {
			const keys: string[] = Object.keys(formGroupOrArray.controls);
			for (let i: number = 0; i < keys.length; i++) {
				const control: FormControl | FormGroup | FormArray = formGroupOrArray.controls[keys[i]];
				if (control instanceof FormControl) {
					control.markAsTouched();
					control.markAsDirty();
				} else if (control instanceof FormGroup || control instanceof FormArray) {
					this.markFormGroupTouchedAndDirty(control);
				}
			}
		}
	}

	static markFormGroupUntouched(formGroupOrArray: FormGroup | FormArray): void {
		if (formGroupOrArray.controls) {
			const keys: string[] = Object.keys(formGroupOrArray.controls);
			for (let i: number = 0; i < keys.length; i++) {
				const control: FormControl | FormGroup | FormArray = formGroupOrArray.controls[keys[i]];
				if (control instanceof FormControl) {
					control.markAsUntouched();
					control.markAsPristine();
				} else if (control instanceof FormGroup || control instanceof FormArray) {
					this.markFormGroupTouchedAndDirty(control);
				}
			}
		}
	}

	static arrayIncludesArray(a1: any[], a2: any[]): boolean {
		if (Utilities.isVoid(a1)) {
			return false;
		}
		if (Utilities.isVoid(a1)) {
			return false;
		}
		for (let i: number = 0; i < a2.length; i++) {
			if (!a1.includes(a2[i])) {
				return false;
			}
		}
		return true;
	}

	static escapeSpecialChart(value: string): string | null {
		if (typeof value !== 'string') {
			return value;
		}
		return value.replace(/\\n/g, '')
			.replace(/\\r/g, '')
			.replace(/\\t/g, '')
			.replace(/\\b/g, '')
			.replace(/\\f/g, '');
	}

	static capitalizeFirstLetter(str: string): string {
		if (Utilities.isVoid(str) || str.length < 1) {
			return '';
		}
		return str[0].toUpperCase() + str.slice(1);
	}

	static redirectToUri(redirectUri: any): any {
		if (redirectUri) {
			window.open(
				redirectUri, '_blank'
			);
		}
		return;
	}

	static createAlertTagsUserSettings(tags: Set<TagItem>): TagItemSettings[] {
		const list: Array<TagItemSettings> = [];
		tags.forEach((tag: TagItem) => {
			if (!Utilities.isVoid(tag)) {
				list.push({uid: tag.uid, label: tag.newLabel || tag.label});
			}
		});
		return list;
	}

	static getValueFromRoute(route: Route, key: string): string | string[] | null {
		if (!Utilities.isVoid(route) && !Utilities.isVoid(route.data) && !Utilities.isVoid(route.data[key])) {
			if (route.data[key].length > 1) {
				const profileKeys: string[] = [];
				for (let i: number = 0; i < route.data[key].length; i++) {
					profileKeys.push(route.data[key][i]);
				}
				return profileKeys;
			} else {
				return route.data[key];
			}
		}
		return null;
	}

	static deepCopy(srcObj: any): any {
		// Handle primitive and null values
		if (!srcObj || ['number', 'boolean', 'bigint', 'string'].includes(typeof srcObj)) {
			return srcObj;
		}

		// Handle Date
		if (srcObj instanceof Date) {
			const clonedObj: Date = new Date();
			clonedObj.setTime(srcObj.getTime());
			return clonedObj;
		}

		// Handle array
		if (srcObj instanceof Array) {
			const clonedObj: Array<any> = [];
			srcObj.forEach(item => clonedObj.push(this.deepCopy(item)));
			return clonedObj;
		}

		// Handle Map
		if (srcObj instanceof Map) {
			const clonedObj: Map<any, any> = new Map();
			srcObj.forEach((value, key) => clonedObj.set(this.deepCopy(key), this.deepCopy(value)));
			return clonedObj;
		}

		// Handle Object
		if (srcObj instanceof Object) {
			const clonedObj: any = {};
			Object.keys(srcObj).forEach(attribute => clonedObj[attribute] = this.deepCopy(srcObj[attribute]));
			return clonedObj;
		}
	}

	static mapToObj<V>(map: Map<string, V>): {} {
		return Array.from(map).reduce((obj, [key, value]) => {
			obj[key] = value;
			return obj;
		}, {});
	}

	static setOptionsWithCommodityId(value: string, options?: RequestOptionsArgs): RequestOptionsArgs {
		if (!options) {
			options = new RequestOptions();
		}
		if (!options.headers) {
			options.headers = new Headers();
		}
		if (value !== '') {
			value = value.substring(0, value.length - 1);
		}
		options.headers.append('nemo-commodity-id', value);
		return options;
	}
	
	static nullish(item: any, nullish: any) {
		// Simulazione dell'operatore nullish coaleshing ??
		return item ? item : nullish;
	}
	
	static truncateNumber(num: number): number {

		if (!num) return 0;
	
		const DIGITS = 2;
		return Math.trunc(num*Math.pow(10, DIGITS))/Math.pow(10, DIGITS);
	}

	static isAllowedKeys(key: string): boolean {
		
		/*	
		 *	In base al codice della tastiera
		 *	
		const range = [
			// Lettere
			[65, 90],

			// Numeri
			[48, 57], [96, 105],

			// Punteggiatura
			[188, 190],
		];
	
		return range
						.map(x => Array.from( {length: (x[1]-x[0]+1)}, (_, i) => x[0]+i+'' ) ) 
						.flat()
						.includes(key);

		*/ 

		return [
			...Array.from({ length: 26 }, (_, i) => String.fromCharCode('a'.charCodeAt(0) + i)),
			...Array.from({ length: 26 }, (_, i) => String.fromCharCode('A'.charCodeAt(0) + i)),
			...Array.from({ length: 10 }, (_, i) => i.toString()),
			'.', ',', ':', ';', '-', "'", '"', 'Backspace', 'Delete'
		].includes(key);
	}
	
	static form(): any {

		return ({

			getFormControlFromAbstractControl: (control: AbstractControl): FormControl => {
				return control as FormControl;
			},
			
			getFormArrayFromAbstractControl: (control: AbstractControl): FormArray => {
				return control as FormArray;
			}
		});
	}

	static isValidJSON(str: string): boolean {

		try {
			JSON.parse(str);
		} catch (e) {
				return false;
		}
		return true;
	}
	
	/**
	 * NB: VA IN ERRORE E RENDE Utilities undefined NEGLI ALTRI FILE
	 * 
	 * 
	 * wrapper per sleep dentro un altro file di utilities
	 * @param {number} delay
	 * @returns {Promise<any>}
	static async sleep(delay: number): Promise<any> {
		
	try	{
			
			return sleep(delay);

		} catch (e) {

		logger.error(e);
	}
	
	return;
}
*/

	/**
	 * Normalizza un numero di telefono in formato E.164 per l'Italia.
	 * Esempi:
	 *  - "+39()3404455678" -> "+393404455678"
	 *  - "340 445 5678"   -> "+393404455678"
	 *  - "0039-3404455678"-> "+393404455678"
	 */
	static sanitizeItalianPhone(phone: any): string {
		if (phone === null || phone === undefined) { return phone; }
		let value: string = String(phone).trim();
		// 1) 0039... -> +39...
		value = value.replace(/^00/, '+');
		// 2) Mantieni solo cifre e l'eventuale + iniziale
		value = value.replace(/(?!^\+)[^\d]/g, '');
		const hasPlus = value.charAt(0) === '+';
		const digits = hasPlus ? value.slice(1) : value;
		// 3) Se già inizia con 39, restituisci come E.164
		if (digits.indexOf('39') === 0) {
			return '+' + digits;
		}
		// 4) Se non c'è prefisso e la lunghezza è 10/11, presume Italia
		if (!hasPlus && digits.length >= 10 && digits.length <= 11) {
			return '+39' + digits;
		}
		// 5) Altrimenti, restituisci con o senza + coerentemente
		return hasPlus ? ('+' + digits) : digits;
	}

}

export interface MethodDatePickerInterface {
	doSameThing(): any;

	setErrorDateValidator(obj: any): any;

	setErrorMinValidator(obj: any): any;

	setErrorMaxValidator(obj: any): any;

	clearValidators(obj: any): any;
}

export class PrimitiveValue<T> {
	value: T;

	constructor(v: T) {
		this.value = v;
	}
}

export class ElementOffset {
	private top: number = 0;
	private left: number = 0;

	constructor(top: number, left: number) {
		this.top = top;
		this.left = left;
	}

	getTop(): number {
		return this.top;
	}

	getLeft(): number {
		return this.left;
	}
}

export function ValidateNumber(control: AbstractControl): { [key: string]: boolean } {
	const controlValue: string = !!control.value ? control.value : '';
	let previousNumber: string = !!controlValue ? controlValue.charAt(controlValue.length - 1) : '';
	let equalsNumberCounter: number = 0;

	for (let i: number = controlValue.length; i > (controlValue.length >= 7 ? (controlValue.length - 7) : (controlValue.length - (controlValue.length - 2))); i--) {
		if (previousNumber === controlValue.charAt(i - 1)) {
			equalsNumberCounter++;
		}
		previousNumber = controlValue.charAt(i - 1);
	}

	return equalsNumberCounter === (controlValue.length >= 7 ? 7 : (controlValue.length - 2)) ? {hasEqualsNumber: true} : null;
}

export enum EEnvironmentType {
	LOCAL      = 'local',
	DEV        = 'dev',
	STAGE      = 'stage',
	PRE        = 'pre',
	PRODUCTION = 'production',
}

export function handleHttpAuthServiceResp<T>(obs: Subscriber<T>, cbSuccess?: Function, cbError?: Function, cbComplete?: Function): any {

	// function subscribe next()
	const next = function(res: any): void {
		const content = !Utilities.isEmpty(res._body) ? res.json() : null;
		if (!res.ok) {
			obs.error(new ErrorResponse(content));
			return;
		}
		try {
			obs.next(cbSuccess && cbSuccess(content));
		} catch (err) {
			console.error(err);
			obs.error(new ErrorResponse(err));
		}
	};

	// function subscribe error()
	const error = function(err): void {
		cbError && cbError();
		console.error(err);
		obs.error(new ErrorResponse(err));
	};

	// function subscribe complete()
	const complete = function(): void {
		// silence is gold
		// cbComplete && cbComplete();
	};

	return [next, error, complete];
}
